// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"12040d47","354":"c9d4ae60","399":"8db42725","838":"d1d738f4","963":"8b5dead2"}[chunkId] + ".js";
};